const TAGS = [
  ["link", { rel: "manifest", href: "/admin.webmanifest" }],
  ["link", { rel: "apple-touch-icon", href: "/admin-icon-180.png" }],
  ["meta", { name: "apple-mobile-web-app-capable", content: "yes" }],
  ["meta", { name: "mobile-web-app-capable", content: "yes" }],
  ["meta", { name: "apple-mobile-web-app-title", content: "Namonics Admin" }],
  ["meta", { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" }],
];

export function enableAdminPwa() {
  TAGS.forEach(([tag, attrs]) => {
    const key = attrs.rel || attrs.name;
    if (document.head.querySelector(`[data-admin-pwa="${key}"]`)) return;
    const el = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    el.setAttribute("data-admin-pwa", key);
    document.head.appendChild(el);
  });
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", "#111318");
  if ("serviceWorker" in navigator) navigator.serviceWorker.register("/admin-sw.js", { scope: "/admin" }).catch(() => {});
}
